// Libraries
var React = require('react');

// Components
var CallToAction = require('CallToAction/CallToAction');
var RestrictedComponent = require('RestrictedComponent/RestrictedComponent');

// Styles
require('./InfoBannerModule.scss');

class InfoBannerModule extends React.Component {
	// componentDidMount() {
	// 	const picturefill = require('picturefill');
	// 	picturefill();
	// }

	createDescription = () => {
        return {__html: this.props.data.description};
	};

	render() {
		let imageContent = (
			<div className="InfoBanner__image" ref={(image) => { this.image = image; }} data-bg={this.props.data.image.smallUrl + '*,*' + this.props.data.image.mediumUrl + '*,*' + this.props.data.image.largeUrl + '*,*' + this.props.data.image.extraLargeUrl} id={this.props.data.id}>
			</div>
		);
		return (
			<div className="InfoBanner">
				<div className="InfoBanner__container">
					<RestrictedComponent hasAccess={!this.props.data.link || (this.props.data.link && this.props.data.link.hasAccess)} isVideo={false}>
						{this.props.data.link &&
							<a href={this.props.data.link.url} target={this.props.data.link.newWindow ? "_blank" : "_self"} rel={this.props.data.link.newWindow ? "noopener noreferrer" : undefined}>
								{imageContent}
							</a>
						}
						{!this.props.data.link &&
							imageContent
						}
						<div className="InfoBanner__content">
							{this.props.data.tags !== null &&
								<div className="InfoBanner__tags">
									{this.props.data.tags !== null && this.props.data.tags.map((item) => {
										return (
											<a className="InfoBanner__tag" rel="nofollow" href={item.url} key={item.id}>{item.hashtag}</a>
										);
									})}
								</div>
							}
							<h3 className="InfoBanner__title">{this.props.data.link ? (<a href={this.props.data.link.url} target={this.props.data.link.newWindow ? "_blank" : "_self"} rel={this.props.data.link.newWindow ? "noopener noreferrer" : undefined}>{this.props.data.title}</a>) : (this.props.data.title)}</h3>
							<div className="InfoBanner__description" dangerouslySetInnerHTML={this.createDescription()}></div>
							{this.props.data.link &&
								<CallToAction {...this.props.data.link} />
							}
						</div>
					</RestrictedComponent>
				</div>
			</div>
		)
	}
}

module.exports = InfoBannerModule;



// WEBPACK FOOTER //
// ./src/components/InfoBanner/InfoBannerModule.js